import Container from "react-bootstrap/Container";
import { Modal, Button } from "react-bootstrap";
import "./Manual.css";
import defaultImage from "../../assets/images/default-image.png";
import { useNavigate, useParams } from "react-router-dom";
import { Routers } from "./../../routes/Constant";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/swiper-bundle.css";
import "../aboutinstructor/AboutInstructor.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import CSS for styling
import { message } from "antd";
import { Link } from "react-router-dom";
import {
  CalenderAvailabilityData,
  getData,
} from "../../redux/slice/CalenderSlice";
import {
  citylistByState,
  fetchInstructorsFilter,
  fetchInstructorsSingle,
} from "../../redux/slice/InstructorSlice.js";
import { CalendarModal } from "./CalendarModal.jsx";
import RediscoverChooseUs from "../../components/newpages/rediscover/RediscoverChooseUs";
import StateSuburb from "../../components/statesuburb/StateSuburb";
import { GetRoadHome } from "../../components/newHome/GetRoadHome";
import locale from "antd/es/date-picker/locale/en_US.js";
export const Manual = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showCalendar, setShowCalendar] = useState(false);
  const secondSectionRef = useRef(null);
  const location = useLocation();
  const targetRef = useRef(null);

  const { instructorsFilter, loading, error } = useSelector(
    (state) => state.instructors
  );
  const data = instructorsFilter?.length > 0 ? instructorsFilter[0]?.data : [];

  const [selectedId, setSelectedId] = useState(data?.[1]?.id);
  const [hideInput, setHideInput] = useState(false);
  const { state, city } = useParams();
  const { citylist } = useSelector(
    (state) => state.instructors || { citylist: [] }
  );
  const calendarRef = useRef(null);
  const swiperRef = useRef(null);
  const [event, setEvents] = useState("");
  const Availability = useSelector((state) => state.calender.calender);
  const Events = Availability?.calendar_data;

  const [show, setShow] = useState(false);
  const [showS, setShowS] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleServicesClose = () => setShowS(false);
  const handleServicesShow = () => setShowS(true);

  useEffect(() => {
    if (!loading && data.length === 0) {
    }
  }, [loading, data]);

  useEffect(() => {
    if (window.localStorage.getItem("prevsUrl")) {
      setHideInput(true);
    } else {
      setHideInput(false);
      // if (targetRef.current) {
      //   targetRef.current.scrollIntoView({ behavior: "instant" });
      // }
    }
  }, [location]);

  useEffect(() => {
    const capitalize = (str) =>
      str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
    const cityObject = citylist?.[0]?.find(
      (e) => e?.place_name == capitalize(city)
    );
    const citynewid = cityObject ? cityObject.id : null; // Get the id or null if not found
    if (state) {
      dispatch(citylistByState(state));
      dispatch(
        fetchInstructorsFilter({
          state: state,
          city_id: citynewid,
        })
      );
    }
  }, [state, city]);

  const cityIdhandler = (city_id) => {
    dispatch(
      fetchInstructorsFilter({
        city_id: city_id,
      })
    );
  };

  const addBookNowEvents = (events) => {
    // Get the current date
    const currentDate = new Date();

    // Calculate the start date: current date minus 2 months
    const weekStart = new Date(currentDate);
    weekStart.setMonth(weekStart.getMonth() - 2);
    weekStart.setHours(0, 0, 0, 0); // Set to start of the day

    // Calculate the end date: current date plus 2 months
    const weekEnd = new Date(currentDate);
    weekEnd.setMonth(weekEnd.getMonth() + 2);
    weekEnd.setHours(23, 59, 59, 999); // Set to end of the day

    const bookNowEvents = [];
    const hoursOfDay = Array.from({ length: 24 }, (_, index) => index);

    // Iterate over each day between weekStart and weekEnd
    for (
      let date = new Date(weekStart);
      date <= weekEnd;
      date.setDate(date.getDate() + 1)
    ) {
      for (const hour of hoursOfDay) {
        const startTime = new Date(date.setHours(hour, 0, 0, 0));
        const endTime = new Date(startTime.getTime() + 60 * 60 * 1000);

        // Find if there's an existing event at this time slot
        const eventForThisSlot = events.find(
          (event) =>
            new Date(event.start).toISOString() === startTime.toISOString()
        );

        // If no event is found, add the "Book Now" event
        if (!eventForThisSlot) {
          const isExpired = startTime < currentDate; // Check if the event is before the current date and time

          bookNowEvents.push({
            title: "Book Now",
            start: startTime.toISOString(),
            end: endTime.toISOString(),
            className: isExpired ? "book_now expired" : "book_now", // Apply 'expired' class if the event is in the past
          });
        }
      }
    }

    // Return combined events: existing events + "Book Now" events
    return [...events, ...bookNowEvents];
  };

  // useEffect(() => {
  //   if (secondSectionRef.current) {
  //     secondSectionRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [data]);

  const calenderMainRef = useRef();

  // useEffect(() => {
  //   if (calenderMainRef.current) {
  //     calenderMainRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [selectedId]);

  // Get updated events with "Book Now" slots added
  const updatedEvents = addBookNowEvents(Events || []);

  const changeInstructorHandler = (id) => {
    setSelectedId(id);
    setSelectedPackages([])
  };

  useEffect(() => {
    setSelectedId(data?.[1]?.id);
  }, [data]);

  const [packages, setPackages] = useState([]);

  const instructorsdetails = useSelector(
    (state) => state?.instructors?.instructorsdetails
  );

  useEffect(() => {
    if (selectedId) {
      // ✅ Prevents invalid call if selectedId is null
      dispatch(fetchInstructorsSingle(selectedId));
      dispatch(CalenderAvailabilityData(selectedId));
    }
  }, [dispatch, selectedId]);

  useEffect(() => {
    if (instructorsdetails && Array.isArray(instructorsdetails)) {
      const response = instructorsdetails[0]?.data?.package;
      setPackages(response);
    }
  }, [instructorsdetails]);

  const handleEventClick = (info) => {
    const { event } = info; // Extract the clicked event
    const selectedDate = new Date(event.start); // Get the event start date
    const currentDateTime = new Date(); // Current date and time
    const selectedDateTime = new Date(selectedDate); // Ensure selectedDate has time if needed

    // Condition: Prevent interaction with events in the past (including time)
    if (selectedDateTime < currentDateTime) {
      message.error("Cannot interact with past events."); // Display error message
      return;
    }

    const date = new Date(event.start);

    // Format the date as: YYYY-MM-DDTHH:MM:SS+05:30
    const offset = -date.getTimezoneOffset(); // Offset in minutes
    const sign = offset >= 0 ? "+" : "-";
    const hoursOffset = String(Math.floor(Math.abs(offset) / 60)).padStart(
      2,
      "0"
    );
    const minutesOffset = String(Math.abs(offset) % 60).padStart(2, "0");

    const formattedDate =
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}T` +
      `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}` +
      `${sign}${hoursOffset}:${minutesOffset}`;

    // Condition 2: Check if the clicked event is "Book Now"
    if (event.title === "Book Now") {
      const selectedStartDate = new Date(event.start);

      if (!selectedId) {
        message.warning("Please Select Instructor");
        return;
      }

      let selectedPackage = null;
      let formattedEnd = null;

      const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const mi = String(date.getMinutes()).padStart(2, "0");
        const ss = String(date.getSeconds()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
      };

      if (
        selectedPackages.length > 0 &&
        selectedPackages[0] !== null &&
        selectedPackages[0] !== undefined
      ) {
        const selectedPackageId = selectedPackages[0];
        selectedPackage = packages.find(
          (p) => p.package_id === selectedPackageId
        );

        if (!selectedPackage || !selectedPackage.package_id) {
          message.error("Selected package data not found.");
          return;
        }

        const durationInMinutes = selectedPackage.time;
        const endDate = new Date(
          selectedStartDate.getTime() + durationInMinutes * 60000
        );
        formattedEnd = formatDate(endDate);
      }

      const formattedStart = formatDate(selectedStartDate);

      localStorage.setItem("selectedDate", JSON.stringify(formattedStart));
      localStorage.setItem("startDateTime", formattedStart);
      localStorage.setItem("endDateTime", formattedEnd || "");

      const newtime = selectedStartDate
        .toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
        .toLowerCase();
      const newday = selectedStartDate.toLocaleDateString("locale", {
        weekday: "long",
      });
      const currDate = selectedStartDate.toLocaleDateString("en-US", {
        month: "long",
        day: "2-digit",
      });
      dispatch(getData([{ newtime, newday, currDate }]));

      const navigateState = selectedPackage
        ? {
            selectedPackages: selectedPackage?.package_id
              ? [
                  {
                    package_id: selectedPackage.package_id,
                    duration: selectedPackage.time,
                    amount: selectedPackage.amount,
                    start_date: [formattedStart], // now an array
                    end_date: [formattedEnd], // now an array
                    lesson_count: selectedPackage.lesson_count,
                  },
                ]
              : [],
          }
        : {}; // If no package, send empty state

      navigate(Routers.Progress, { state: navigateState });

      message.success(
        `You selected the "Book Now" slot at ${event.start.toLocaleString()}`
      );
    } else {
      message.info(`Slot ${event.title}`);
    }
  };

  const [selectedDateStudent, setSelectedDateStudent] = useState(new Date());

  const handleDateClick = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month and pad it with zero if needed
    const day = String(date.getDate()).padStart(2, "0"); // Get day and pad it with zero if needed
    const formattedDate = `${year}-${month}-${day}`;
    setSelectedDateStudent(date);
  };

  // Use an effect to update FullCalendar when the date changes
  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(selectedDateStudent); // Navigate to the selected date
      calendarApi.changeView("timeGridDay", selectedDateStudent);
    }
  }, [selectedDateStudent]); // Update on selectedDateStudent change

  const [selectedPackages, setSelectedPackages] = useState([]);

const handleSelectPackage = (package_id) => {
  setSelectedPackages([package_id]);
};

  return (
    <>
      {!hideInput && <GetRoadHome />}
      <section className="aboutInstructor_section" ref={secondSectionRef}>
        <Container>
          <div className="aboutInstructor--inner">
            <div className="instructor_list">
              {instructorsFilter?.[0]?.data?.map((instructor, index) => {
                if (instructor.id === selectedId) {
                  return (
                    <div className="selectInstructorImg--wrapper" key={index}>
                      {/* <div className="selected_instructor test">
                        <img
                          className="img-fluid"
                          src={
                            instructor.profile_image
                              ? `https://keyzi.com.au/keyzi-admin/public/${instructor.profile_image}`
                              : defaultImage
                          }
                          alt={instructor.name}
                        />
                        <h5>{instructor.name}</h5>
                      </div> */}
                      <div className="student_calender d-flex mx-auto">
                        <Calendar
                          onChange={handleDateClick}
                          value={selectedDateStudent}
                        />
                      </div>
                    </div>
                  );
                }
                return null; // This ensures that non-matching instructors are ignored
              })}
            </div>
            {instructorsFilter?.length > 0 ? (
              <Swiper
                slidesPerView={5}
                spaceBetween={5}
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
                ref={swiperRef}
                breakpoints={{
                  0: { slidesPerView: 5, spaceBetween: 0 },
                  768: { slidesPerView: 5, spaceBetween: 10 },
                  992: { slidesPerView: 5, spaceBetween: 10 },
                  1200: { slidesPerView: 5, spaceBetween: 10 },
                }}
              >
                {instructorsFilter?.[0]?.data?.map((instructor, index) => (
                  <SwiperSlide key={instructor.id}>
                    <div
                      className="d-flex other_instructor_list"
                      onClick={() => changeInstructorHandler(instructor.id)}
                    >
                      <div className="text-center">
                        <div className="instructorimg_list_wrapper">
                          <img
                            src={
                              instructor.profile_image
                                ? `https://keyzi.com.au/keyzi-admin/public/${instructor.profile_image}`
                                : defaultImage
                            }
                            alt={instructor.name}
                            className={`${
                              instructor.id === selectedId && "active"
                            }`}
                          />
                        </div>
                        <p>{instructor.name}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <p>Loading instructor data...</p>
            )}
            <div className="instructor_list">
              {instructorsFilter?.[0]?.data?.map((instructor, index) => {
                if (instructor.id === selectedId) {
                  return (
                    <div className="selectInstructorImg--wrapper" key={index}>
                      <div className="selected_instructor w-auto mx-auto">
                        <div>
                          <img
                            className="img-fluid"
                            src={
                              instructor.profile_image
                                ? `https://keyzi.com.au/keyzi-admin/public/${instructor.profile_image}`
                                : defaultImage
                            }
                            alt={instructor.name}
                          />
                        </div>
                        <div className="text-start">
                          <h5 class="mb-2">
                            {instructor.name} <br />
                            {instructor.transmission_type}
                          </h5>
                          <div className="d-flex gap-2">
                            <Button
                            variant="primary"
                            onClick={handleShow}
                          >
                            Profile
                          </Button>
                          <Button
                            variant="primary"
                            onClick={handleServicesShow}
                          >
                            Services
                          </Button>
                          </div>
                         {selectedPackages.length > 0 && (
  <Link className="package-link" onClick={handleServicesShow}>
    {packages
      .filter((p) => selectedPackages.includes(p.package_id))
      .map((p) => p.package_name)
      .join(", ")}
  </Link>
)}


                          <Modal show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                              <Modal.Title>{instructor.name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <img
                                src={
                                  instructor.profile_image
                                    ? "https://keyzi.com.au/keyzi-admin/public/" +
                                      instructor.profile_image
                                    : defaultImage
                                }
                                alt={instructor.name}
                                style={{
                                  width: "90px",
                                  height: "90px",
                                  borderRadius: "100%",
                                  objectFit: "cover",
                                  margin: "15px",
                                }}
                              />
                              {instructor?.gender && (
                                <div className="row">
                                  <div class="col-5">Gender:</div>
                                  <div class="col">{instructor.gender}</div>
                                </div>
                              )}
                              {instructor?.transmission_type && (
                                <div className="row">
                                  <div class="col-5">Transmission: </div>
                                  <div class="col">
                                    {instructor.transmission_type}
                                  </div>
                                </div>
                              )}
                              {instructor?.experience && (
                                <div className="row">
                                  <div className="col-5">Experience:</div>
                                  <div className="col">
                                    {instructor.experience}
                                  </div>
                                </div>
                              )}
                              {instructor?.licence_number && (
                                <div className="row">
                                  <div className="col-5">Licence Number:</div>
                                  <div className="col">
                                    {instructor.licence_number}
                                  </div>
                                </div>
                              )}
                              {instructor?.licence_expiry_date && (
                                <div className="row">
                                  <div className="col-5">
                                    Licence Expiry Date:
                                  </div>
                                  <div className="col">
                                    {instructor.licence_expiry_date}
                                  </div>
                                </div>
                              )}
                              {instructor?.vehicle_model && (
                                <div className="row">
                                  <div className="col-5">Vehicle Model:</div>
                                  <div className="col">
                                    {instructor.vehicle_model}
                                  </div>
                                </div>
                              )}
                              {instructor?.bio && (
                                <div className="row">
                                  <div className="col-4">Bio:</div>
                                  <div>{instructor.bio}</div>
                                </div>
                              )}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="primary"
                                onClick={() => {
                                  navigate(Routers.OurInstructor, {
                                    state: { myData: instructor },
                                  });
                                }}
                              >
                                Read More
                              </Button>
                            </Modal.Footer>
                          </Modal>
                          <Modal show={showS} onHide={handleServicesClose}>
  <Modal.Header closeButton>
    <Modal.Title>Our Services</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="row">
      {packages && packages.length > 0 ? (
        packages.map((pkg) => (
          <div className="col-12 mb-2" key={pkg.package_id}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="selectedPackage" // ensures single selection
                id={`package_${pkg.package_id}`}
                checked={selectedPackages.includes(pkg.package_id)}
                onChange={() => handleSelectPackage(pkg.package_id)}
              />
              <label
                className="form-check-label"
                htmlFor={`package_${pkg.package_id}`}
              >
                <strong>{pkg.package_name}</strong> - ${pkg.amount} | {pkg.time} mins | {pkg.lesson_count} lesson
              </label>
            </div>
          </div>
        ))
      ) : (
        <div className="col-12">
          <p className="text-muted">No service available.</p>
        </div>
      )}
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleServicesClose}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

                        </div>
                      </div>
                    </div>
                  );
                }
                return null; // This ensures that non-matching instructors are ignored
              })}
            </div>
            <div className="calender-wrapper" ref={calenderMainRef}>
            <FullCalendar
  ref={calendarRef}
  plugins={[
    dayGridPlugin,
    bootstrap5Plugin,
    timeGridPlugin,
    listPlugin,
    interactionPlugin,
  ]}
  events={updatedEvents}
  slotMinTime="05:00"
  slotMaxTime="22:00"
  eventClick={handleEventClick}
  selectable={true}
  initialView="timeGridDay"
  initialDate="2025-02-27"
  eventTimeFormat={{
    hour: 'numeric',
    minute: '2-digit',
    meridiem: 'short', // Will show "am"/"pm" instead of "a"/"p"
    hour12: true
  }}
  dayHeaderContent={({ date }) => {
    const dayName = date.toLocaleDateString("en-US", {
      weekday: "short",
    });
    const day = date.getDate();
    const year = date.getFullYear();
    const month = date.toLocaleDateString("en-US", {
      month: "short",
    });
    return `${dayName} ${day}/${month}/${year}`;
  }}
  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
  }}
  titleFormat={{
    year: "numeric",
    month: "short",
    day: "numeric",
    omitCommas: true,
  }}
  contentHeight="500px"
/>

            </div>
          </div>
        </Container>
      </section>
      {selectedId && showCalendar && (
        <CalendarModal
          showCalendar={showCalendar}
          id={selectedId}
          setShowCalendar={setShowCalendar}
        />
      )}
      {state && (
        <StateSuburb
          cityIdhandler={cityIdhandler}
          citylist={citylist}
          name={`Driving Instructors in ${state}`}
        />
      )}
      <RediscoverChooseUs />
    </>
  );
};
